import { get, patch, post, postFormData } from '../helpers/api_helper';

const BASE_URL = '/customer-service';

export const ticketService = {
  getTickets: (params = {}) => {
    const queryParams = new URLSearchParams();

    if (Array.isArray(params.filter_state)) {
      params.filter_state.forEach((state) => {
        queryParams.append('filter_state', state);
      });
    }

    if (params.exclude_state) {
      queryParams.append('exclude_state', params.exclude_state);
    }

    if (params.skip !== undefined) {
      queryParams.append('skip', params.skip);
    }

    if (params.take !== undefined) {
      queryParams.append('take', params.take);
    }

    if (params.sort_by) {
      queryParams.append('sort_by', params.sort_by);
    } else {
      queryParams.append('sort_by', 'created_at');
    }

    if (params.order_by) {
      queryParams.append('order_by', params.order_by);
    } else {
      queryParams.append('order_by', 'desc');
    }

    const query = queryParams.toString();
    return get(`${BASE_URL}/tickets${query ? `?${query}` : ''}`);
  },
  getTicket: (ticketId) => get(`${BASE_URL}/tickets/${ticketId}`),
  createTicket: (data) => post(`${BASE_URL}/tickets`, data),

  // Articles (Messages)
  getTicketArticles: (ticketId) => get(`${BASE_URL}/tickets/${ticketId}/articles`),
  createTicketArticle: (data) => post(`${BASE_URL}/tickets/articles`, data),

  // States and Priorities
  getTicketStates: () => get(`${BASE_URL}/ticket_states`),
  getTicketPriorities: () => get(`${BASE_URL}/ticket_priorities`),

  // Attachments
  createTicketAttachment: (data) => post(`${BASE_URL}/tickets/attachments`, data),
  createArticleAttachment: (data) => post(`${BASE_URL}/tickets/articles/attachments`, data),

  createTicketWithAttachments: async (formData) => {
    const response = await postFormData(`${BASE_URL}/tickets/attachments`, formData);
    return response.data;
  },

  createArticleWithAttachments: async (formData) => {
    const response = await postFormData(`${BASE_URL}/tickets/articles/attachments`, formData);
    return response;
  },

  getArticleAttachment: async (ticketId, articleId, attachmentId, filename) => {
    const response = await get(`${BASE_URL}/${ticketId}/${articleId}/${attachmentId}`, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(response);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  getArticleAttachmentUrl: async (ticketId, articleId, attachmentId) => {
    const response = await get(`${BASE_URL}/${ticketId}/${articleId}/${attachmentId}`, {
      responseType: 'blob',
    });
    return window.URL.createObjectURL(new Blob([response.data]));
  },

  markUnreadMessages: async (ticketId) => {
    try {
      const response = await patch(`${BASE_URL}/tickets/${ticketId}/mark_unread_messages`);
      return response.data;
    } catch (error) {
      console.error('Error marking messages as read:', error);
      throw error;
    }
  },
};
